const offZooSlide = () => {
	setTimeout(function () {
		const bannerClass = "off-zoo-banner";
		const offZoo = document.querySelector(".off-zoo");
		if (!offZoo) return;
		const banner = offZoo.querySelector(".off-zoo__text-slider");
		if (!banner) return;
		const text = banner.querySelector("p");
		if (!text) return;
		const span = document.createElement("span");
		span.setAttribute("aria-hidden", "true");
		span.textContent = text.textContent;

		const original = text.cloneNode(true);
		original.textContent = "";
		original.appendChild(span.cloneNode(true));
		original.style.fontSize = banner.offsetHeight + "px";
		original.classList.add("original", bannerClass);

		const double = text.cloneNode(true);
		double.textContent = "";
		double.appendChild(span.cloneNode(true));
		double.style.fontSize = banner.offsetHeight + "px";
		double.classList.add("replica", bannerClass);

		text.remove();
		banner.append(original);
		banner.append(double);
	}, 100);
};

const offZooSlideStyles = () => {
	const bannerClass = document.querySelector(".off-zoo__text-slider");
	if (bannerClass) {
		const original = bannerClass.querySelector(".original");
		if (!original) return;
		const replica = bannerClass.querySelector(".replica");
		if (!replica) return;
		const slideHigh = bannerClass.offsetHeight + "px";
		setTimeout(function () {
			replica.style.fontSize = slideHigh;
			original.style.fontSize = slideHigh;
		}, 100);
	}
};

const offZooHoverImage = () => {
	const items = document.querySelectorAll(".off-zoo__template__wrapper");

	if (!items.length) return;

	document.querySelectorAll(".off-zoo__template__image").forEach((image) => {
		image.classList.remove("active");
	});

	items.forEach((item) => {
		item.addEventListener("mouseenter", () => {
			document
				.querySelectorAll(".off-zoo__template__image")
				.forEach((image) => {
					image.classList.remove("active");
				});

			const image = item.querySelector(".off-zoo__template__image");

			if (image) {
				image.classList.add("active");
			}
		});

		item.addEventListener("mouseleave", () => {
			const image = item.querySelector(".off-zoo__template__image");

			if (image) {
				image.classList.remove("active");
			}
		});
	});
};

export { offZooSlide, offZooSlideStyles, offZooHoverImage };
